import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RxDealsHttpClient } from '../../../../shared/_services/server-clients';
import type { DealPortfolio, ExchangeDeal, PortfolioScopeResponse } from '../../../../shared/_models/models';
import type { ResponseFromServer } from '../../../../shared/_models/response-from-server.model';

export class ExchangeDealFormApiService {
  constructor(private readonly rxDealsHttpClient: RxDealsHttpClient) {}

  createExchangeDeal(currentDeal: ExchangeDeal): Observable<ResponseFromServer<ExchangeDeal>> {
    const relativePath = 'deals';
    return this.rxDealsHttpClient.post<ExchangeDeal, ExchangeDeal>(relativePath, currentDeal);
  }

  getPortfolios(dealPartnerIds: number[] = [], ownedOnly = false): Observable<DealPortfolio[]> {
    const params = {
      ...(dealPartnerIds.length ? { dealPartnerIds: dealPartnerIds.join(',') } : {}),
      ...(ownedOnly ? { ownedOnly: 'true' } : {})
    };
    return this.rxDealsHttpClient.get<DealPortfolio[]>('portfolios', { params })
      .pipe(map(response => response.data ?? []));
  }

  getUserPortfolioScope(): Observable<number[]> {
    return this.rxDealsHttpClient.get<PortfolioScopeResponse>('portfolios/scope')
      .pipe(map(response => response.data?.portfolioIds ?? []));
  }
}
